module.exports = __webpack_public_path__ + "img/electric_reserved_selected.a63dca1a.svg";